module.exports = __webpack_public_path__ + "static/media/r341.9a59917d.jpg";